import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cityName',
})
export class CityNamePipe implements PipeTransform {
  transform(city: string): unknown {
    if (city) {
      const cityLowercase = city.toLowerCase();
      const existDC = cityLowercase.includes('d.c');
      const splitName = cityLowercase.split(' ');
      let capitalWords: string[];
      if (existDC) {
        capitalWords = splitName.map((word) => {
          if (word === 'd.c') {
            return word.toUpperCase();
          } else {
            return word.charAt(0).toUpperCase() + word.slice(1);
          }
        });
      } else {
        capitalWords = splitName.map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        });
      }

      return capitalWords.join(' ');
    } else {
      return 'N/A';
    }
  }
}
